import { render, staticRenderFns } from "./file-video.vue?vue&type=template&id=7b5c8bac&"
import script from "./file-video.vue?vue&type=script&lang=ts&"
export * from "./file-video.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b5c8bac')) {
      api.createRecord('7b5c8bac', component.options)
    } else {
      api.reload('7b5c8bac', component.options)
    }
    module.hot.accept("./file-video.vue?vue&type=template&id=7b5c8bac&", function () {
      api.rerender('7b5c8bac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/file-video.vue"
export default component.exports